import React from 'react';
class Hexagons extends React.Component {
    render() {
        return (
            <div className="canvas-wrapper">
                <canvas id="c"></canvas>
            </div>
        );
    }
}

export default Hexagons;


// WEBPACK FOOTER //
// ./src/components/home/Juxtapose/hexagons.js